const SiteProblems = () => {
    return (
        <>
            <h2>PROBLEMS</h2>
        </>
    )
}

export default SiteProblems;